import React from 'react';
import { colors, spacing } from '../../theme';
import { Text } from '@chakra-ui/react';
import { Stack } from '../Stack';
import { servicebookingFlowStore } from '../../store/ServiceBookingFlowStore';
import { observer } from 'mobx-react-lite'; // Import observer

export interface TimePickerHeaderProps {
  /**
   * Transformed appointment slots data returned from the API.
   */
  dates?: string[][];
}

// Wrap the component with the observer HOC
export const TimePickerHeader = observer((props: TimePickerHeaderProps) => {
  const { dates = [] } = props;
  const isServiceBooking = servicebookingFlowStore.isServiceBooking;
  
  // Get the buttonText color from the store
  const buttonTextColor = isServiceBooking && servicebookingFlowStore.configurationDetails?.colorScheme?.buttonText 
    ? servicebookingFlowStore.configurationDetails.colorScheme.buttonText 
    : "#B92F2F";

  return (
    <Stack
      direction="row"
      style={$datesContainer}
    >
      {dates.map((date, index) => (
        <Stack
          key={`date-row-${index}`}
          style={{
            ...$datesStyle,
            ...(index % 2 !== 0 && { backgroundColor: colors.palette.neutral200 }),
          }}
        >
          <Text
            color={buttonTextColor}
            fontWeight={'bold'}
            fontSize={{ base: 'xs', md: 'sm', lg: 'sm' }}
          >{date[0]}</Text>
          <Text
            fontSize={{ base: 'xs', md: 'sm', lg: 'sm' }}
            fontWeight={'bold'}
          >{`${date[1]} ${date[2]}`}</Text>
        </Stack>
      ))}
    </Stack>
  );
});

const $datesContainer: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  gap: 0,
};

const $datesStyle: React.CSSProperties = {
  flex: 1,
  gap: 0,
  alignItems: 'center',
  borderColor: colors.border,
  borderTopWidth: 1,
  borderRightWidth: 1,
  borderLeftWidth: 1,
  borderBottomWidth: 1,
  padding: spacing.sm,
};